module.exports = __webpack_public_path__ + "static/media/the-hidden-hunger-affectiong-billions.4eecb474.jpg";